import { Text } from '@weareconceptstudio/core';

//* Style
import PrivacyPolicyItemStyle from './style';

//* Components
import Editor from '@/components/Editor';

const PrivacyPolicyItem = ({ title, description }) => {
	return (
		<PrivacyPolicyItemStyle>
			<Text className={'h5 title-category'}>{title}</Text>

			<Editor
				data={description}
				className={`editor`}
			/>
		</PrivacyPolicyItemStyle>
	);
};

export default PrivacyPolicyItem;
